import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const PAGE_TITLES = {
  '/dashboard': 'Tableau de bord',
  '/projects': 'Mes projets',
  '/projects/new': 'Nouveau projet',
  '/admin': 'Administration',
  '/admin/users': 'Gestion des utilisateurs',
  '/admin/settings': 'Paramètres système',
};

export default function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Titre dynamique basé sur la route
  const title =
    PAGE_TITLES[location.pathname] ||
    (location.pathname.startsWith('/projects/') ? 'Détail du projet' : 'AI Orchestrator');

  return (
    <div className="min-h-screen bg-background">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((c) => !c)}
      />
      <div
        className="transition-all duration-200"
        style={{
          marginLeft: sidebarCollapsed
            ? 'var(--sidebar-width-collapsed)'
            : 'var(--sidebar-width)',
        }}
      >
        <Header title={title} />
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
